export const missionSets = [
  {
    id: 'general',
    title: 'General Language-Learning Mini Missions',
    missions: [
      {
        id: 'general-1',
        title: 'Speak Freely With Zero Pressure',
        body: 'Say random phrases from your phrase bank out loud to people or to yourself. Focus only on being understood, not on perfection.',
      },
      {
        id: 'general-2',
        title: 'Hit 50% Pronunciation Accuracy',
        body: 'Choose any set of phrases you like and aim to pronounce half of them clearly enough that your conversation partner understands you most of the time.',
      },
      {
        id: 'general-3',
        title: 'Decode Replies Using Context',
        body: 'When someone responds, try to guess the meaning using context, familiar words, tone, and gestures. Treat it like a puzzle.',
      },
      {
        id: 'general-4',
        title: 'Conversation Autopsy',
        body: 'After each conversation, write down what you couldn’t say, what you couldn’t understand, and what you wish you knew. Then build a solutions document with fixes, phrases, and strategies.',
      },
      {
        id: 'general-5',
        title: 'Build a Personal Cheat Sheet',
        body: 'Create a page of phrases related to topics you want to talk about. Include key verbs, connectors, useful nouns, and conversation navigation phrases.',
      },
      {
        id: 'general-6',
        title: 'Practice Raw Sounds Only',
        body: 'Spend a session pronouncing letters, syllables, and basic sounds with no words. This builds accent and listening ability.',
      },
      {
        id: 'general-7',
        title: 'Grammar Pattern Recognition',
        body: 'Study how basic sentences are built. Then listen for those patterns in real conversations and repeat them until automatic.',
      },
      {
        id: 'general-8',
        title: 'Verb-Driven Sentence Building',
        body: 'Take a verb list and plug each verb into simple sentence structures you already know. Example: “I want ___”, “I need ___”, “Can you ___”.',
      },
      {
        id: 'general-9',
        title: 'Vocabulary Expansion Mission',
        body: 'Pick a list of nouns and adjectives. Combine them with your verbs and connectors to create colorful, flexible sentences.',
      },
      {
        id: 'general-10',
        title: 'Cultural Immersion Day',
        body: 'Spend time learning about history, beliefs, mythology, humor, and street-smart expressions. Culture makes language stick.',
      },
    ],
  },
  {
    id: 'scenario',
    title: 'Scenario-Based Mini Missions',
    missions: [
      {
        id: 'scenario-1',
        title: 'Greet and Introduce Yourself',
        body: 'Start a conversation with a greeting, your name, and a polite question about the other person.',
      },
      {
        id: 'scenario-2',
        title: 'Share an Interest',
        body: 'Talk about something you enjoy and ask if the other person likes it too or has other interests.',
      },
      {
        id: 'scenario-3',
        title: 'Navigate Not Understanding',
        body: 'Tell the other person you didn’t understand. Ask them to help using writing, translation apps, pictures, or simpler phrases.',
      },
      {
        id: 'scenario-4',
        title: 'Order Food at a Restaurant',
        body: 'Ask for a table, order a dish, inquire about ingredients, and ask follow-up questions.',
      },
      {
        id: 'scenario-5',
        title: 'Ask for Step-By-Step Guidance',
        body: 'Request that your conversation partner explain a recipe, process, or task in simple steps.',
      },
      {
        id: 'scenario-6',
        title: 'Resolve a Misunderstanding Peacefully',
        body: 'Explain politely that you didn’t mean any offense and want no problems. Clarify what you meant.',
      },
      {
        id: 'scenario-7',
        title: 'Buy a Snack or Drink',
        body: 'Ask what’s popular, choose an item, ask about price, and complete the purchase.',
      },
      {
        id: 'scenario-8',
        title: 'Ask for Directions',
        body: 'Approach someone and ask how to get to a place. Try to understand their instructions using context clues.',
      },
      {
        id: 'scenario-9',
        title: 'Use Public Transportation',
        body: 'Ask about bus/train times, ticket prices, and whether you’re on the right route.',
      },
      {
        id: 'scenario-10',
        title: 'Handle a Small Emergency',
        body: 'Explain a simple problem (headache, dizziness, lost item) and ask for help or directions.',
      },
      {
        id: 'scenario-11',
        title: 'Shop for Clothing',
        body: 'Ask for sizes, colors, fitting rooms, and recommendations in a department store.',
      },
      {
        id: 'scenario-12',
        title: 'Check Into a Hotel',
        body: 'Request a room, ask about breakfast, ask for extra towels, or report a small issue.',
      },
      {
        id: 'scenario-13',
        title: 'Make Small Talk',
        body: 'Ask about someone’s day, comment on something interesting, and share a simple opinion.',
      },
      {
        id: 'scenario-14',
        title: 'Practice Problem-Solving Language',
        body: 'Tell someone something is wrong, ask for help, request clarification, and confirm understanding.',
      },
      {
        id: 'scenario-15',
        title: 'Do a Banking Interaction',
        body: 'Ask about fees, deposits, withdrawals, or card issues in a simple, calm way.',
      },
      {
        id: 'scenario-16',
        title: 'Send or Track a Package',
        body: 'Ask about shipping times, tracking, missing packages, or returns.',
      },
      {
        id: 'scenario-17',
        title: 'Handle Household Issues',
        body: 'Explain a simple home problem (light not working, water not running) and ask for help or instructions.',
      },
    ],
  },
];
